import { render, staticRenderFns } from "./DashProfile.vue?vue&type=template&id=47f7ca85&"
import script from "./DashProfile.vue?vue&type=script&lang=js&"
export * from "./DashProfile.vue?vue&type=script&lang=js&"
import style0 from "./DashProfile.vue?vue&type=style&index=0&id=47f7ca85&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports